import React, { useState, useEffect, useRef } from "react";
// HAPUS: import { useNavigate } from "react-router-dom";
import "../styles/Survey.css";
import "../styles/Survey_Mobile.css";
import {
  getGuruForSurvey,
  getPertanyaan,
  submitSurvey,
  getAllSemester,
  getSurveyDetail,
} from "../api";

function SurveyPage({ user }) {
  // HAPUS: const navigate = useNavigate();

  const [guruList, setGuruList] = useState([]);
  const [selectedGuru, setSelectedGuru] = useState(null);
  const [pertanyaan, setPertanyaan] = useState([]);
  const [jawaban, setJawaban] = useState({});
  const [resume, setResume] = useState("");
  const [wordCount, setWordCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingGuru, setLoadingGuru] = useState(true);
  const [showPreview, setShowPreview] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [surveyId, setSurveyId] = useState(null);
  const [surveyStatus, setSurveyStatus] = useState(null);
  const [error, setError] = useState("");
  const [semesterList, setSemesterList] = useState([]);
  const [semester, setSemester] = useState("");
  const [submitMode, setSubmitMode] = useState("final");
  const [isRedirecting, setIsRedirecting] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const firstUnansweredRef = useRef(null);

  useEffect(() => {
    loadSemesterList();
  }, []);

  useEffect(() => {
    if (semester) {
      loadGuru(semester);
    }
  }, [semester]);

  useEffect(() => {
    if (successMessage) {
      const t = setTimeout(() => {
        setSuccessMessage("");
      }, 4000);
      return () => clearTimeout(t);
    }
  }, [successMessage]);

  const loadSemesterList = async () => {
    try {
      const res = await getAllSemester();
      if (res.data.success) {
        const semesters = res.data.data;
        setSemesterList(semesters);
        const activeSem = semesters.find((s) => s.is_active === 1);
        if (activeSem) {
          setSemester(activeSem.kode_semester);
          loadGuru(activeSem.kode_semester);
        }
      }
    } catch (err) {
      console.error("Error loading semester list:", err);
    }
  };

  const loadGuru = async (selectedSemester) => {
    setLoadingGuru(true);
    setError("");

    try {
      const res = await getGuruForSurvey(
        user.ref_id,
        selectedSemester || semester
      );

      if (res.data.success) {
        setGuruList(res.data.data);
      } else {
        setError(res.data.message || "Gagal memuat data guru");
      }
    } catch (err) {
      setError("Gagal memuat data guru");
    } finally {
      setLoadingGuru(false);
    }
  };

  const startSurvey = async (guru) => {
    if (
      guru.survey_status === "final" &&
      guru.sudah_survey == 1 &&
      !canEditSurvey(guru.survey_date)
    ) {
      alert("Periode edit survey sudah berakhir");
      return;
    }

    setLoading(true);
    setError("");
    setSelectedGuru(guru);

    try {
      const qRes = await getPertanyaan();
      if (!qRes.data.success) {
        setError("Gagal memuat pertanyaan");
        return;
      }

      setPertanyaan(qRes.data.data);

      if (guru.sudah_survey == 1 && guru.survey_id) {
        setIsEditing(true);
        setSurveyId(guru.survey_id);
        setSurveyStatus(guru.survey_status);

        const detail = await getSurveyDetail(guru.survey_id);
        if (detail.data.success) {
          setJawaban(detail.data.data.jawaban);
          setResume(detail.data.data.resume || "");

          const words = (detail.data.data.resume || "")
            .trim()
            .split(/\s+/)
            .filter((w) => w.length > 0);
          setWordCount(words.length);
        } else {
          setError("Gagal memuat data survey sebelumnya");
        }
      } else {
        setIsEditing(false);
        setSurveyId(null);
        setSurveyStatus(null);
        setJawaban({});
        setResume("");
        setWordCount(0);
      }
    } catch (err) {
      setError("Terjadi kesalahan saat memulai survey");
    } finally {
      setLoading(false);
    }
  };

  const canEditSurvey = (submitDate) => {
    if (!submitDate) return true;
    const daysPassed =
      (Date.now() - new Date(submitDate)) / (1000 * 60 * 60 * 24);
    return daysPassed <= 7;
  };

  const handleJawaban = (id, nilai) => {
    setJawaban((prev) => ({ ...prev, [id]: nilai }));
  };

  const handleResumeChange = (e) => {
    const text = e.target.value;
    setResume(text);
    const words = text
      .trim()
      .split(/\s+/)
      .filter((w) => w.length > 0);
    setWordCount(words.length);
  };

  const calculateProgress = () => {
    const totalPertanyaan = pertanyaan.reduce(
      (sum, aspek) => sum + aspek.pertanyaan.length,
      0
    );
    const answered = Object.keys(jawaban).length;
    return {
      answered,
      total: totalPertanyaan,
      percentage: totalPertanyaan > 0 ? (answered / totalPertanyaan) * 100 : 0,
    };
  };

  const getUnansweredQuestions = () => {
    const unanswered = [];
    pertanyaan.forEach((aspek, aspekIdx) => {
      aspek.pertanyaan.forEach((p, pIdx) => {
        if (!jawaban[p.pertanyaan_id]) {
          unanswered.push({
            aspek: aspek.nama_aspek,
            aspekIdx,
            pertanyaanIdx: pIdx,
            pertanyaan: p.pertanyaan,
          });
        }
      });
    });
    return unanswered;
  };

  const handleShowPreview = (mode = "final") => {
    setSubmitMode(mode);

    if (mode === "final") {
      const totalPertanyaan = pertanyaan.reduce(
        (sum, aspek) => sum + aspek.pertanyaan.length,
        0
      );

      if (Object.keys(jawaban).length !== totalPertanyaan) {
        const unanswered = getUnansweredQuestions();
        setError(
          `Masih ada ${unanswered.length} pertanyaan yang belum dijawab`
        );

        if (firstUnansweredRef.current) {
          firstUnansweredRef.current.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        return;
      }

      if (wordCount < 40) {
        setError(`Resume minimal 40 kata (saat ini: ${wordCount} kata)`);
        return;
      }

      if (wordCount > 300) {
        setError(`Resume maksimal 300 kata (saat ini: ${wordCount} kata)`);
        return;
      }
    } else {
      if (Object.keys(jawaban).length === 0) {
        setError("Minimal jawab 1 pertanyaan untuk menyimpan draft");
        return;
      }
    }

    setError("");
    setShowPreview(true);
  };

  const handleSubmit = async () => {
    console.log("=== SUBMIT SURVEY START ===");
    setLoading(true);
    setError("");

    try {
      const jawabanArray = Object.keys(jawaban).map((key) => ({
        pertanyaan_id: parseInt(key),
        nilai: jawaban[key],
      }));

      const data = {
        siswa_id: user.ref_id,
        guru_id: selectedGuru.id,
        semester,
        resume_siswa: resume,
        jawaban: jawabanArray,
        status: submitMode,
      };

      if (isEditing && surveyId) {
        data.survey_id = surveyId;
      }

      console.log("Data yang akan dikirim:", data);
      console.log("Total jawaban:", jawabanArray.length);
      console.log("Resume length:", resume.length);
      console.log("Word count:", wordCount);

      const res = await submitSurvey(data);
      console.log("Response dari server:", res);

      if (res && res.data && res.data.success) {
        console.log("✅ Survey berhasil disimpan!");
        console.log("Survey ID:", res.data.survey_id);
        console.log("Status:", res.data.status);

        const message =
          submitMode === "draft"
            ? "Draft berhasil disimpan! Anda bisa melanjutkan nanti."
            : isEditing
            ? "Survey berhasil diperbarui!"
            : "Survey berhasil dikirim! Terima kasih atas partisipasi Anda.";

        // Set flag redirecting SEBELUM reset form
        setIsRedirecting(true);
        setSuccessMessage(message);

        console.log("Menutup modal preview...");
        // Tutup modal preview dulu
        setShowPreview(false);

        console.log("Reset semua state...");
        // Reset semua state form secara manual - PENTING untuk memastikan kembali ke list
        setSelectedGuru(null);
        setPertanyaan([]);
        setJawaban({});
        setResume("");
        setWordCount(0);
        setError("");
        setSurveyId(null);
        setSurveyStatus(null);
        setIsEditing(false);

        console.log("Reload daftar guru...");
        // Reload daftar guru untuk update status survey
        await loadGuru(semester);

        console.log("Reset redirecting flag...");
        // Reset flag redirecting setelah semua selesai
        setTimeout(() => {
          setIsRedirecting(false);
          console.log("=== SUBMIT SURVEY COMPLETE ===");
        }, 100);
      } else {
        console.error("❌ Server response NOT success:", res);
        const errorMsg = res?.data?.message || "Gagal mengirim survey";
        console.error("Error message:", errorMsg);
        if (res?.data?.debug) {
          console.error("Debug info:", res.data.debug);
        }
        setError(errorMsg);
        setShowPreview(false);
      }
    } catch (err) {
      console.error("❌ EXCEPTION saat submit survey:", err);
      console.error("Error details:", {
        message: err.message,
        stack: err.stack,
        response: err.response,
      });

      let errorMsg = "Terjadi kesalahan saat mengirim survey";

      if (err.response) {
        console.error("Server responded with error:", err.response);
        errorMsg = err.response.data?.message || errorMsg;
        if (err.response.data?.debug) {
          console.error("Server debug info:", err.response.data.debug);
        }
      } else if (err.request) {
        console.error("Request was made but no response:", err.request);
        errorMsg =
          "Tidak dapat terhubung ke server. Periksa koneksi internet Anda.";
      }

      setError(errorMsg);
      setShowPreview(false);
    } finally {
      setLoading(false);
      console.log("Loading state set to false");
    }
  };

  const resetForm = (force = false) => {
    if (!force && !isRedirecting && Object.keys(jawaban).length > 0) {
      const ok = window.confirm(
        "Yakin ingin membatalkan? Jawaban Anda akan hilang."
      );
      if (!ok) return;
    }

    setSelectedGuru(null);
    setPertanyaan([]);
    setJawaban({});
    setResume("");
    setWordCount(0);
    setError("");
    setSurveyId(null);
    setSurveyStatus(null);
    setIsEditing(false);
    setShowPreview(false);
  };

  const getNilaiLabel = (nilai) => {
    switch (nilai) {
      case 5:
        return "Sangat Baik";
      case 4:
        return "Baik";
      case 3:
        return "Cukup";
      case 2:
        return "Kurang";
      case 1:
        return "Sangat Kurang";
      default:
        return "";
    }
  };

  const PreviewModal = () => {
    const calculateAspekScore = (aspekId) => {
      const aspek = pertanyaan.find((a) => a.aspek_id === aspekId);
      if (!aspek) return 0;

      const scores = aspek.pertanyaan.map((p) => jawaban[p.pertanyaan_id] || 0);
      const sum = scores.reduce((a, b) => a + b, 0);
      return (sum / scores.length).toFixed(2);
    };

    const calculateTotalScore = () => {
      const allScores = Object.values(jawaban);
      if (allScores.length === 0) return 0;
      const sum = allScores.reduce((a, b) => a + b, 0);
      return (sum / allScores.length).toFixed(2);
    };

    return (
      <div className="modal-overlay" onClick={() => setShowPreview(false)}>
        <div className="preview-modal" onClick={(e) => e.stopPropagation()}>
          <div className="preview-header">
            <h2>
              {submitMode === "draft"
                ? "💾 Preview Draft"
                : "🚀 Konfirmasi Kirim Survey"}
            </h2>
            <button className="close-btn" onClick={() => setShowPreview(false)}>
              ×
            </button>
          </div>

          <div className="preview-content">
            <div className="preview-guru-info">
              <div className="preview-foto">
                {selectedGuru.foto_url ? (
                  <img
                    src={selectedGuru.foto_url}
                    alt={selectedGuru.nama_lengkap}
                  />
                ) : (
                  <div className="preview-foto-placeholder">
                    {selectedGuru.nama_lengkap.charAt(0)}
                  </div>
                )}
              </div>
              <div>
                <h3>{selectedGuru.nama_lengkap}</h3>
                <p>NIP: {selectedGuru.nip}</p>
                <p>📚 {selectedGuru.mata_pelajaran}</p>
              </div>
            </div>

            <div className="preview-section">
              <h3>📊 Progress Jawaban</h3>
              <p>
                {Object.keys(jawaban).length} dari{" "}
                {pertanyaan.reduce(
                  (sum, aspek) => sum + aspek.pertanyaan.length,
                  0
                )}{" "}
                pertanyaan terjawab
              </p>
            </div>

            {Object.keys(jawaban).length > 0 && (
              <>
                <div className="preview-section">
                  <h3>Nilai Per Aspek</h3>
                  {pertanyaan.map((aspek) => (
                    <div key={aspek.aspek_id} className="preview-aspek">
                      <h4>{aspek.nama_aspek}</h4>
                      <div className="preview-aspek-score">
                        {calculateAspekScore(aspek.aspek_id)}
                      </div>
                    </div>
                  ))}
                </div>

                <div className="preview-total-score">
                  <h4>Total Nilai Keseluruhan</h4>
                  <div className="score">{calculateTotalScore()}</div>
                </div>
              </>
            )}

            {resume && (
              <div className="preview-resume">
                <h4>Resume Anda</h4>
                <p>{resume}</p>
                <small>{wordCount} kata</small>
              </div>
            )}

            {submitMode === "draft" && (
              <div className="draft-notice">
                ℹ️ Draft akan disimpan dan Anda bisa melanjutkan nanti
              </div>
            )}
          </div>

          <div className="preview-actions">
            <button
              className="btn-cancel"
              onClick={() => setShowPreview(false)}
            >
              ← Kembali Edit
            </button>
            <button
              className="btn-submit-final"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading
                ? submitMode === "draft"
                  ? "Menyimpan..."
                  : "Mengirim..."
                : submitMode === "draft"
                ? "💾 Simpan Draft"
                : isEditing
                ? "✓ Update Survey"
                : "🚀 Kirim Survey"}
            </button>
          </div>
        </div>
      </div>
    );
  };

  if (selectedGuru) {
    const progress = calculateProgress();
    const unansweredQuestions = getUnansweredQuestions();

    return (
      <div className="survey-page">
        <div className="survey-form">
          {/* Sticky Header Guru */}
          <div className="guru-sticky-header">
            <div className="guru-info-compact">
              <div className="guru-foto-small">
                {selectedGuru.foto_url ? (
                  <img
                    src={selectedGuru.foto_url}
                    alt={selectedGuru.nama_lengkap}
                  />
                ) : (
                  <div className="foto-placeholder-small">
                    {selectedGuru.nama_lengkap.charAt(0)}
                  </div>
                )}
              </div>
              <div className="guru-details">
                <h3 className="guru-name-sticky">
                  {selectedGuru.nama_lengkap}
                </h3>
                <p className="guru-meta">📚 {selectedGuru.mata_pelajaran}</p>
                <p className="guru-semester">🗓️ Semester {semester}</p>
              </div>
            </div>
            {surveyStatus === "draft" && (
              <span className="draft-badge-small">📝 Draft</span>
            )}
          </div>

          <div className="form-content-scrollable">
            <div className="form-header">
              <h2>Survey Kepuasan Siswa</h2>
              {surveyStatus === "draft" && (
                <p className="draft-badge">📝 Draft - Belum Final</p>
              )}
            </div>

            {error && <div className="error-box">{error}</div>}

            <div className="progress-container">
              <div className="progress-info">
                <span className="progress-label">Progress Pengisian</span>
                <div className="progress-numbers">
                  <span className="progress-count">{progress.answered}</span>
                  <span className="progress-total">/ {progress.total}</span>
                </div>
              </div>
              <div className="progress-bar-bg">
                <div
                  className="progress-bar-fill"
                  style={{ width: `${progress.percentage}%` }}
                ></div>
              </div>
              <div className="progress-percentage">
                {Math.round(progress.percentage)}% selesai
              </div>
            </div>

            {loading ? (
              <div className="loading-overlay">
                <div className="spinner"></div>
                <p>Memuat pertanyaan...</p>
              </div>
            ) : null}

            {pertanyaan.map((aspek, idx) => (
              <div key={aspek.aspek_id} className="aspek-card">
                <h3 className="aspek-title">
                  {idx + 1}. {aspek.nama_aspek}
                </h3>

                {aspek.pertanyaan.map((p, pIdx) => {
                  const isFirstUnanswered =
                    unansweredQuestions.length > 0 &&
                    unansweredQuestions[0].pertanyaan === p.pertanyaan;

                  return (
                    <div
                      key={p.pertanyaan_id}
                      className={`pertanyaan-item ${
                        !jawaban[p.pertanyaan_id] ? "unanswered" : ""
                      }`}
                      ref={isFirstUnanswered ? firstUnansweredRef : null}
                    >
                      <p className="pertanyaan-text">
                        {idx + 1}.{pIdx + 1}. {p.pertanyaan}
                        {!jawaban[p.pertanyaan_id] && (
                          <span className="required-mark">*</span>
                        )}
                      </p>

                      <div className="jawaban-grid">
                        {[5, 4, 3, 2, 1].map((nilai) => (
                          <button
                            key={nilai}
                            type="button"
                            className={`btn-jawaban ${
                              jawaban[p.pertanyaan_id] === nilai ? "active" : ""
                            }`}
                            onClick={() =>
                              handleJawaban(p.pertanyaan_id, nilai)
                            }
                          >
                            <span className="nilai-number">{nilai}</span>
                            <span className="nilai-label">
                              {getNilaiLabel(nilai)}
                            </span>
                          </button>
                        ))}
                      </div>
                    </div>
                  );
                })}
              </div>
            ))}

            <div className="resume-card">
              <h3>Resume Anda</h3>
              <p className="resume-hint">
                Tuliskan pendapat Anda tentang guru ini (40-300 kata untuk
                submit final)
              </p>
              <textarea
                value={resume}
                onChange={handleResumeChange}
                placeholder="Contoh: Pak/Bu guru sangat menguasai materi dan cara mengajarnya mudah dipahami..."
                rows="6"
              ></textarea>
              <div
                className={`word-count ${
                  wordCount < 40
                    ? "warning"
                    : wordCount > 300
                    ? "error"
                    : "success"
                }`}
              >
                {wordCount} kata
                {wordCount < 40 && " (min 40 untuk final)"}
                {wordCount > 300 && " (max 300)"}
                {wordCount >= 40 && wordCount <= 300 && " ✓"}
              </div>
            </div>

            <div className="action-buttons">
              <button
                className="btn-draft"
                onClick={() => handleShowPreview("draft")}
                disabled={loading}
              >
                💾 Simpan Draft
              </button>
              <button
                className="btn-submit"
                onClick={() => handleShowPreview("final")}
                disabled={loading}
              >
                🚀 Kirim Survey
              </button>
            </div>
          </div>
          {/* End of form-content-scrollable */}

          <button className="btn-back" onClick={() => resetForm(false)}>
            ← Kembali ke Daftar Guru
          </button>
        </div>

        {showPreview && <PreviewModal />}
      </div>
    );
  }

  return (
    <div className="survey-page">
      <div className="survey-header">
        <h2>Survey Kepuasan Siswa</h2>
        <p className="survey-subtitle">Yayasan Perguruan Pembda Nias</p>
      </div>

      <div className="disclaimer-box">
        <div className="disclaimer-icon">📋</div>
        <h3 className="disclaimer-title">Informasi Survey</h3>
        <div className="disclaimer-content">
          <div className="disclaimer-points">
            <div className="point-item">
              <span className="point-number">1.</span>
              <p>
                Survey ini dilakukan oleh{" "}
                <strong>Yayasan Perguruan Pembda Nias</strong> untuk mengukur
                tingkat kepuasan siswa terhadap Layanan Guru selama ini. Survey
                ini bersifat <strong>anonim</strong>—yang bisa dilihat adalah
                hasil/rekapitulasi, sedangkan identitas siswa tidak dapat
                dilihat.
              </p>
            </div>

            <div className="point-item">
              <span className="point-number">2.</span>
              <p>
                Untuk itu diharapkan agar siswa dapat mengisi survey ini dengan{" "}
                <strong>jujur apa adanya</strong> tanpa tekanan untuk perbaikan
                mutu pendidikan ke depan.
              </p>
            </div>

            <div className="point-item">
              <span className="point-number">3.</span>
              <p>
                Diharapkan Anda mengisi survey dengan tuntas. Namun sistem
                memungkinkan bisa menyimpan <strong>draft</strong> terlebih
                dahulu serta <strong>mengedit jawaban</strong>. Perlu diketahui
                bahwa jawaban yang diperhitungkan adalah jawaban yang sudah{" "}
                <strong>dikirim (final)</strong>.
              </p>
            </div>

            <div className="point-item">
              <span className="point-number">4.</span>
              <p>
                <strong>Selamat melakukan survey.</strong>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="guru-list-container">
        {loadingGuru ? (
          <div className="loading-state">
            <div className="spinner"></div>
            <p>Memuat data guru...</p>
          </div>
        ) : error ? (
          <div className="error-state">
            <span className="error-icon">⚠️</span>
            <p>{error}</p>
            <button className="btn-retry" onClick={() => loadGuru()}>
              🔄 Coba Lagi
            </button>
          </div>
        ) : guruList.length === 0 ? (
          <div className="empty-state">
            <div className="empty-icon">📚</div>
            <h3>Tidak Ada Guru</h3>
            <p>Tidak ada guru yang mengajar Anda untuk semester ini</p>
          </div>
        ) : (
          <>
            <div className="summary-cards">
              <div className="summary-card total">
                <div className="summary-icon">👥</div>
                <div className="summary-content">
                  <span className="summary-label">Total Guru</span>
                  <span className="summary-value">{guruList.length}</span>
                </div>
              </div>
              <div className="summary-card success">
                <div className="summary-icon">✅</div>
                <div className="summary-content">
                  <span className="summary-label">Survey Final</span>
                  <span className="summary-value">
                    {guruList.filter((g) => g.survey_status === "final").length}
                  </span>
                </div>
              </div>
              <div className="summary-card warning">
                <div className="summary-icon">📝</div>
                <div className="summary-content">
                  <span className="summary-label">Draft</span>
                  <span className="summary-value">
                    {guruList.filter((g) => g.survey_status === "draft").length}
                  </span>
                </div>
              </div>
              <div className="summary-card info">
                <div className="summary-icon">⏳</div>
                <div className="summary-content">
                  <span className="summary-label">Belum Survey</span>
                  <span className="summary-value">
                    {guruList.filter((g) => !g.sudah_survey).length}
                  </span>
                </div>
              </div>
            </div>

            <div className="guru-grid">
              {guruList.map((guru) => {
                const canEdit =
                  guru.survey_status === "final" &&
                  guru.sudah_survey == 1 &&
                  canEditSurvey(guru.survey_date);

                const isDraft = guru.survey_status === "draft";
                const isFinal = guru.survey_status === "final";

                return (
                  <div
                    key={guru.id}
                    className={`guru-card ${
                      isFinal ? "completed" : isDraft ? "draft" : ""
                    }`}
                    onClick={() => startSurvey(guru)}
                  >
                    <div className="guru-foto-wrapper">
                      {guru.foto_url ? (
                        <img
                          src={guru.foto_url}
                          alt={guru.nama_lengkap}
                          className="guru-foto-survey"
                        />
                      ) : (
                        <div className="guru-foto-placeholder-survey">
                          <span className="guru-initial-survey">
                            {guru.nama_lengkap.charAt(0)}
                          </span>
                        </div>
                      )}
                    </div>

                    <div className="guru-details">
                      <h3>{guru.nama_lengkap}</h3>
                      <p className="guru-nip">NIP: {guru.nip}</p>
                      <p className="guru-mapel">📚 {guru.mata_pelajaran}</p>
                      {guru.sudah_survey == 1 && guru.survey_date && (
                        <p className={`survey-status ${guru.survey_status}`}>
                          {guru.survey_status === "draft"
                            ? "📝 Draft"
                            : "✓ Final"}{" "}
                          •{" "}
                          {new Date(guru.survey_date).toLocaleDateString(
                            "id-ID"
                          )}
                        </p>
                      )}
                    </div>

                    <div className="btn-survey-wrapper">
                      <button
                        className={`btn-survey ${
                          isDraft ? "draft-mode" : canEdit ? "edit-mode" : ""
                        }`}
                        disabled={isFinal && !canEdit}
                      >
                        {guru.sudah_survey == 1
                          ? isDraft
                            ? "📝 Lanjutkan Survey"
                            : canEdit
                            ? "✏️ Edit Survey"
                            : "✓ Survey Selesai"
                          : "📝 Isi Survey"}
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default SurveyPage;
